import { computed } from '@ember/object';
import { equal, or } from '@ember/object/computed';
import Enum from '@square/dashboard-utilities/utils/enum';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import AdjustmentFee from '@square/dashboard-data/models/squareup/beemo/api/v2/models/adjustment-fee';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
const FeeType = new Enum(['FIXED_RATE', 'COST_PLUS']);
const RISK_MANAGER_FEE_PLAN_PRODUCT = 'RISK_MANAGER';
const APP_SUBSCRIPTIONS_MARKETPLACE_FEE_PLAN_PRODUCT = 'APP_SUBSCRIPTIONS_MARKETPLACE';
const INTERNATIONAL_TRANSACTION_FEE_PLAN_PRODUCT = 'INTERNATIONAL_TRANSACTION';
export const FeePlan = ProtoBaseModel.extend({
  discountBasisPoints: attr(Number),
  interchangeCents: attr(Number),
  feePlanProduct: attr(String),
  feePlanId: attr(String),
  taxRateBasisPoints: attr(Number),
  isRiskManager: equal('feePlanProduct', RISK_MANAGER_FEE_PLAN_PRODUCT),
  isAppmFeePlan: equal('feePlanProduct', APP_SUBSCRIPTIONS_MARKETPLACE_FEE_PLAN_PRODUCT),
  isInternationalFeePlan: equal('feePlanProduct', INTERNATIONAL_TRANSACTION_FEE_PLAN_PRODUCT),
  // True for any fee plan that is not the base processing fee (e.g., risk manager,
  // APPM, international). Used by the transaction footer to select the base fee plan
  // via rejectBy('feePlan.isSupplementalFeePlan'). When adding a new fee plan type,
  // add its is* property here so that base fee selection works automatically across
  // all footer components without updating each one individually.
  isSupplementalFeePlan: or('isRiskManager', 'isAppmFeePlan', 'isInternationalFeePlan')
});
export default ProtoBaseModel.extend({
  initialFeeMoney: attr(MoneyProto),
  initialTaxOnFeeMoney: attr(MoneyProto),
  taxOnFeeMoney: attr(MoneyProto),
  adjustmentFeeMoney: repeated(MoneyProto),
  freeProcessingFeeMoney: attr(MoneyProto),
  adjustmentFee: repeated(AdjustmentFee),
  feeType: attr(FeeType),
  feePlan: attr(FeePlan),
  totalInitialFeeMoney: computed('initialFeeMoney', 'initialTaxOnFeeMoney', function () {
    const total = this.initialFeeMoney;
    if (this.initialTaxOnFeeMoney) {
      return total.add(this.initialTaxOnFeeMoney);
    }
    return total;
  }),
  totalFeeMoney: computed('initialFeeMoney', 'taxOnFeeMoney', function () {
    const total = this.initialFeeMoney;
    if (this.taxOnFeeMoney) {
      return total.add(this.taxOnFeeMoney);
    }
    return total;
  }),
  isCostPlus: equal('feeType', FeeType.COST_PLUS)
});